export const getCurrentLocationOffset = () => {
    const offsetInMinutes = new Date().getTimezoneOffset(); // Offset in minutes from UTC
    const offsetInHours = -(offsetInMinutes / 60); // Convert minutes to hours and negate
    const formattedOffset = `${offsetInHours >= 0 ? '+' : '-'}${Math.abs(offsetInHours)
        .toString()
        .padStart(2, '0')}:00`; // Format to "+HH:MM" or "-HH:MM"

    return formattedOffset;
};